import { render, staticRenderFns } from "./MaterialTop.vue?vue&type=template&id=2af60a46&scoped=true"
import script from "./MaterialTop.vue?vue&type=script&lang=js"
export * from "./MaterialTop.vue?vue&type=script&lang=js"
import style0 from "./MaterialTop.vue?vue&type=style&index=0&id=2af60a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af60a46",
  null
  
)

export default component.exports